import { Box, Grid } from "@mui/material";
import { GetServerSideProps } from "next";
import Head from "next/head";
import React from "react";
import LineBuster from "../../../components/client-specific/cne/LineBuster";
import config from "../../../config";
import { EcommerceEvent } from "../../../models/Event";
import { setupStyleMapFromStyleMap } from "../../../utils/helpers";

interface CNEPageProps {
    eventList: EcommerceEvent;
    style: any;
    errorMessage: string | null;
}

export default function CNEPage({
    eventList,
    style,
    errorMessage,
}: CNEPageProps) {
    const pageTitle = `CNE Tickets | AuthentiGATE`;

    React.useEffect(() => {
        if (style?.newStyleMap) {
            setupStyleMapFromStyleMap(style.newStyleMap);
        }
    }, [style]);

    return (
        <>
            <Head>
                <title>{pageTitle}</title>
                <meta name="robots" content="noindex" />
            </Head>
            <main
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    minHeight: "100vh",
                }}
            >
                <LineBuster
                    eventList={eventList}
                    errorMessage={errorMessage}
                    allowedDepartmentIds={[34545, 34602]}
                />
            </main>
        </>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const cartUrl = "cne",
        eventId = 1448;
    let data: any,
        style: any,
        error = false,
        errorMessage: string | null = null;

    let salesContext = "ECOMMERCE";

    try {
        const res = await fetch(
            `${config.BACKEND_URI}/sales/ecommerce-events/${cartUrl}/${eventId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-Sales-Context": salesContext,
                    Cookie: context.req.headers.cookie ?? "",
                },
                credentials: "include",
            },
        );
        if (res.status !== 200) {
            error = true;
            console.log(await res.text());
        } else {
            data = await res.json();
            if (!data.event || !data.event.isActive) {
                errorMessage = "Event is not currently active.";
            }
        }
    } catch (err) {
        console.log(err);
        error = true;
    }

    try {
        const res = await fetch(
            `${config.BACKEND_URI}/sales/cart-style/${cartUrl}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-Sales-Context": "ECOMMERCE",
                },
            },
        );
        if (res.status !== 200) {
            error = true;
            console.log(await res.text());
        } else {
            style = await res.json();
        }
    } catch (err) {
        console.log(err);
        error = true;
    }

    if (style?.newStyleMap) {
        setupStyleMapFromStyleMap(style.newStyleMap);
    }

    return {
        props: { eventList: data, style, errorMessage },
        notFound: error,
    };
};
